import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { BATTLESHIP } from 'HubStyleTokens/colors';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIButton from 'UIComponents/button/UIButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InsertStyles = styled.div.withConfig({
  displayName: "GenericPopoverHeader__InsertStyles",
  componentId: "sc-1torbiq-0"
})([".vertical-spacer{height:24px;width:1px;margin-right:12px;background-color:", ";}.media-type-header{display:flex;justify-content:space-between;align-items:center;width:100%;}"], BATTLESHIP);
export const GenericPopoverHeader = ({
  portalId,
  manageUrl,
  onClickManageButton,
  onViewInsertMenu,
  titleMessage,
  getNewLinkUrl
}) => /*#__PURE__*/_jsxs(InsertStyles, {
  className: "p-x-4 m-bottom-3 is--heading-7 display-flex align-center",
  children: [/*#__PURE__*/_jsx(UIIconButton, {
    use: "link",
    onClick: e => onViewInsertMenu ? onViewInsertMenu(e) : null,
    children: /*#__PURE__*/_jsx(UIIcon, {
      name: "left"
    })
  }), /*#__PURE__*/_jsx("span", {
    className: "vertical-spacer"
  }), /*#__PURE__*/_jsxs("div", {
    className: "media-type-header",
    children: [titleMessage, /*#__PURE__*/_jsxs("div", {
      children: [getNewLinkUrl && /*#__PURE__*/_jsx(UIButton, {
        external: true,
        href: getNewLinkUrl(portalId),
        size: "extra-small",
        use: "tertiary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "draftPlugins.snippetsPlugin.popover.header.createNew"
        })
      }), manageUrl && /*#__PURE__*/_jsx(UIButton, {
        external: true,
        href: manageUrl,
        size: "extra-small",
        use: "tertiary-light",
        onClick: onClickManageButton,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "draftPlugins.snippetsPlugin.popover.header.manage"
        })
      })]
    })]
  })]
});
GenericPopoverHeader.propTypes = {
  manageUrl: PropTypes.string,
  portalId: PropTypes.number.isRequired,
  onClickManageButton: PropTypes.func,
  onViewInsertMenu: PropTypes.func,
  titleMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  getNewLinkUrl: PropTypes.func
};
export default GenericPopoverHeader;